// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1wWTn","noInteraction":"EventWrapper_noInteraction__3ZhC9","pointerPassthrough":"EventWrapper_pointerPassthrough__1qc9c"};